<template>
  <div class="classifyMain">
    <div class="classify">
      <v-container>
        <div class="classify_title">{{ classifyData[dataKey].title }}</div>
      </v-container>
      <div
        v-for="(item, index) in classifyData[dataKey].list"
        :key="item.title"
        class="list"
      >
        <v-container>
          <div :id="index" class="title">{{ item.title }}</div>
        </v-container>

        <img-show
          listTitle=""
          :dataKey="item.dataKey"
          :classify="item.title"
        ></img-show>
      </div>
    </div>
    <div class="explain">
      <div class="explain_title">所有分类</div>
      <ul>
        <li
          v-for="(item, index) in classifyData[dataKey].list"
          :key="item.title"
          @click="liClick(item)"
        >
          <a :href="`#${index}`">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import imgShow from "./Detail/imgShow.vue";

export default {
  name: "Classify",
  components: {
    imgShow,
  },
  data() {
    return {
      dataKey: "ranking",
      classifyData: {
        ranking: {
          title: "动画片排行榜",
          list: [
            {
              title: "益智",
              dataKey: "ranking",
            },
            {
              title: "科幻",
              dataKey: "ranking",
            },
            {
              title: "冒险",
              dataKey: "ranking",
            },
            {
              title: "神话",
              dataKey: "ranking",
            },
            {
              title: "亲子、教育",
              dataKey: "ranking",
            },
            {
              title: "其他",
              dataKey: "ranking",
            },
          ],
        },
        latest: {
          title: "最新上映",
          list: [
            {
              title: "益智",
              dataKey: "latest",
            },
            {
              title: "科幻",
              dataKey: "latest",
            },
            {
              title: "冒险",
              dataKey: "latest",
            },
            {
              title: "亲子、教育",
              dataKey: "latest",
            },
            {
              title: "亲子、益智",
              dataKey: "latest",
            },
            {
              title: "其他",
              dataKey: "latest",
            },
          ],
        },
        hot: {
          title: "热播动画",
          list: [
            {
              title: "益智",
              dataKey: "hot",
            },
            {
              title: "科普",
              dataKey: "hot",
            },
            {
              title: "神话",
              dataKey: "hot",
            },
            {
              title: "历史、益智",
              dataKey: "hot",
            },
            {
              title: "亲子、益智",
              dataKey: "hot",
            },
          ],
        },
        original: {
          title: "国产原创",
          list: [
            {
              title: "益智",
              dataKey: "original",
            },
            {
              title: "教育",
              dataKey: "original",
            },
            {
              title: "科幻",
              dataKey: "original",
            },
            {
              title: "科普",
              dataKey: "original",
            },
            {
              title: "历史、益智",
              dataKey: "original",
            },

            {
              title: "冒险",
              dataKey: "original",
            },
            {
              title: "名著",
              dataKey: "original",
            },
            {
              title: "神话",
              dataKey: "original",
            },
            {
              title: "亲子、教育",
              dataKey: "original",
            },
            {
              title: "亲子、益智",
              dataKey: "original",
            },
            {
              title: "益智、亲情、科普",
              dataKey: "original",
            },
            {
              title: "益智、亲子、轻松",
              dataKey: "original",
            },
            {
              title: "其他",
              dataKey: "original",
            },
          ],
        },
      },
    };
  },
  watch: {
    $route: {
      handler() {
        const query = this.$route.query;
        this.dataKey = query.key || "ranking";
      },
      deep: true,
    },
  },
  created() {
    const query = this.$route.query;
    this.dataKey = query.key || "ranking";
    console.log(query.key);
  },
  mounted() {
    window.scrollTo(0, 0);
    document.getElementById("apps").scrollTop = 0;
  },
  methods: {
    liClick() {},
  },
};
</script>

<style lang="scss" scoped>
.classifyMain {
  width: 100%;
  padding: 20px 100px;
  margin-top: 100px;
  display: flex;
  .explain {
    width: 240px;
    padding-left: 20px;
    position: fixed;
    top: 110px;
    right: 0;
    bottom: 500px;
    .explain_title {
      font-size: 20px;
      font-weight: bolder;
    }
    ul {
      padding: 20px;
      li {
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }
  .classify {
    width: 100%;
    margin-right: 140px;
    border-right: 2px solid #eee;
    .classify_title {
      font-size: 20px;
      font-weight: bolder;
      margin-bottom: 20px;
    }
    .list {
      padding-top: 20px;
      .title {
        font-size: 16px;
        font-weight: bolder;
      }
    }
  }
}
</style>
